import MarkdownRenderer from '@components/markdown-renderer/markdown-renderer';

interface IMarkdownResponseProps {
  message: string;
}

export default function MarkdownResponse({ message }: IMarkdownResponseProps) {
  return <MarkdownRenderer content={message} />;
}
